import React, { useRef } from "react";
import { Box } from "@mui/material";
import { CustomButton } from "../../utils/CustomTagComponents";

const SmartButton = ({ children, endIcon, ...props }) => {
  const btnRef = useRef(null);

  const handleMouseEnter = (e) => {
    const btn = btnRef.current;
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    btn.style.setProperty("--x", `${x}px`);
    btn.style.setProperty("--y", `${y}px`);
  };

  return (
    <CustomButton
      ref={btnRef}
      {...props}
      onMouseEnter={handleMouseEnter}
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        overflow: "hidden",
        "&::before": {
          top: "var(--y)",
          left: "var(--x)",
          zIndex: 0,
        },
        "& > *": {
          zIndex: 1,
        },
        "& .MuiButton-endIcon": {
          marginLeft: "6px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& img": {
          width: "20px",
          height: "20px",
          display: "inline-block",
          verticalAlign: "middle",
          objectFit: "contain",
        },
        ...props.sx,
      }}
    >
      <Box component="span">{children}</Box>
      {endIcon && (
        <Box
          component="span"
          className="MuiButton-endIcon"
          sx={{ display: "inline-flex", alignItems: "center", marginLeft:'0 !important' }}
        >
          {endIcon}
        </Box>
      )}
    </CustomButton>
  );
};

export default SmartButton;
